import { useCallback } from "react";

interface GenerateCodeParams {
    userRequest: string;
    currentContent: string;
    dataContext?: string;
    provider?: "openai" | "anthropic";
    model?: string;
    signal?: AbortSignal;
}

export const useCodeGeneration = () => {
    const generateCode = useCallback(async (params: GenerateCodeParams): Promise<string> => {
        const {
            userRequest,
            currentContent,
            dataContext = "",
            provider = "openai",
            model = provider === "openai" ? "gpt-4o-mini" : "claude-3-haiku-20240307",
            signal,
        } = params;

        const response = await fetch(`${import.meta.env.VITE_BACKEND_URL}/generate-code`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                user_request: userRequest,
                current_content: currentContent,
                data_context: dataContext,
                provider,
                model,
            }),
            signal,
        });

        if (!response.ok) {
            const errorJson = await response.json().catch(() => ({}));
            throw new Error(errorJson.message || "Failed to generate code");
        }

        const json = (await response.json()) as { generated_code: string };
        return json.generated_code;
    }, []);

    return { generateCode } as const;
}; 